import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { IconSelectModalComponent } from './components/icon-select-modal/icon-select-modal.component';

@Component({
  selector: 'app-icon-select-form-field',
  templateUrl: './icon-select-form-field.component.html',
  styleUrls: ['./icon-select-form-field.component.scss']
})
export class IconSelectFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  get icon(): string {
    return this.parentGroup.controls[this.formElement.formControl].value;
  }

  openIconSelectDialog() {
    if (this.readOnly) {
      return;
    }

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = {
      selectedIcon: this.icon
    };

    const dialogRef = this.dialog.open(IconSelectModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data !== undefined && data !== null && data !== '') {
          this.setValue(data)
        }
      }
    );
  }

  setValue(icon: string) {
    this.parentGroup.controls[this.formElement.formControl].setValue(icon);
  }

  isValueSelected(): boolean {
    return this.parentGroup.controls[this.formElement.formControl].value !== null && this.parentGroup.controls[this.formElement.formControl].value !== '';
  }

  clearValue() {
    this.parentGroup.controls[this.formElement.formControl].setValue(null);
  }


}
